<template>
  <div class="all" style="display: none;">
    <!-- <div class="header">
      <img style="width:120px" src="../assets/new_home/logo.png" alt="">
      <div class="contact">
        <img src="../assets/login/phone-logo.png" alt="">
        <div>400-003-1733</div>
      </div>
    </div> -->
    <div class="head_img">
      <div class="titlee">
        <div style="display: flex; align-items: center;">
          <div style="font-size:30px;font-weight: bold;">乾保网</div>
          <span style="font-size:28px;margin: 0 5px 2px 3px;">|</span>
          <div style="font-size:18px;letter-spacing:1px;">专业投标保证保险平台</div>
        </div>
        <div style="font-size:22px;font-weight: bold;">400-003-1733</div>
      </div>
      <img class="picture" src="../assets/new_home/top_bc.png" alt="">
      <div @click="login" style="top: 70%;position: absolute;left: 34%;font-size: 15px;font-weight: bold; color:#ed8f8b; border-radius: 4px;padding: 4px 18px;letter-spacing:2px; background-color: #ffff;
    cursor: pointer;">直接申请</div>
    </div>


    <!-- <div class="top_bc">
      <img class="picture" src="../assets/new_home/participate.png" alt="">
      <img class="code" src="../assets/new_home/activ.png" alt="">
    </div>
    <img class="picture" src="../assets/new_home/activity.png" alt="">
    <img class="picture" src="../assets/new_home/advantage.png" alt=""> -->
    <div class="top_bc">
      <img class="picture" src="../assets/new_home/new-activity.png" alt="">
      <img class="btn" @click="addBtn" src="../assets/new_home/apply_huo1.png" alt="">
    </div>
    <!-- <img class="picture" src="../assets/new_home/han.png" alt=""> -->
    <div class="foo">
      <img class="picture" src="../assets/new_home/han.png" alt="">
      <img @click="han" class="app" style="left: 26.5%;" src="../assets/new_home/small_apply.png" alt="">
      <img @click="han" class="app" style="left: 48.5%;" src="../assets/new_home/small_apply.png" alt="">
      <img @click="han" class="app" style="left: 70%;" src="../assets/new_home/small_apply.png" alt="">
    </div>
    <div style="background-color: #3f3f3f;">
      <div class="footer">
        <ul>
          <li>保函服务</li>
          <li>保险保函</li>
          <li>银行保函</li>
          <li>电子保函</li>
          <li>履约保函</li>
        </ul>
        <ul>
          <li>友情链接</li>
          <li>函驿通</li>
          <li>东方大地保险经纪有限公司</li>
          <li>河北CA</li>
          <li>安诚财险</li>
          <li>大家财险</li>
        </ul>
        <ul>
          <li>联系我们</li>
          <li>服务热线：400-003-1733</li>
          <li>电子邮箱：haneton@163.com</li>
          <li>公司地址：河北省石家庄市新华区中华北大街27号鑫明商务中心211</li>
        </ul>
        <div class="qrcode">
          <div class="official">
            <img src="../assets/new_home/activ.png" alt="">
            <p>乾保网官方客服</p>
          </div>
          <!-- <div class="official">
            <img src="../assets/5b41f45cf2935c2306dce2347945cbb.png" alt="">
            <p>公众号</p>
          </div> -->
        </div>
      </div>
      <div style="display: flex; justify-content: center;font-size: 12px;color: #bbb;">
        <p>
          <a style="color: #bbb; text-decoration: none;" href="https://beian.miit.gov.cn/" target="_blank">ICP备:鄂ICP备16015336号-5</a>
        </p>
        <p style="margin-left:20px;">
          <a>公安备案号:11010502048927</a>
        </p>
      </div>
    </div>
    <div class="success">
      <el-dialog :visible.sync="dialogVisible" width="25%" :show-close="false" :close-on-click-modal="false">
        <img
          style="width: 13%;height: 10%; cursor: pointer; position:absolute; right: 0;transform: translate(30%,-30%);"
          src="../assets/login/close_icon.png" @click="dialogVisible = false" alt="">
        <p
          style="color:#4d4d4d; white-space:nowrap; font-size: 17px; position:absolute; top: 24%;left: 50%;transform: translate(-50%, 0);">
          您是第<span style="color:#de3a22;font-weight: bold;">{{ random }}</span>位获取激励金
        </p>
        <div @click="jump"
          style="width: 60%;height: 10%; cursor: pointer; position:absolute; top: 38%;left: 50%;transform: translate(-50%, 0);">
        </div>
        <img style="width: 30%; position:absolute; top: 72%;left: 50%;transform: translate(-50%, 0);"
          src="../assets/new_home/activ.png" alt="">
      </el-dialog>
    </div>
    <div class="apply">
      <el-dialog :visible.sync="apply" width="24%" :show-close="false" :close-on-click-modal="false" top="13%">
        <img style="width: 13%; cursor: pointer; position:absolute; right: 0;transform: translate(30%,-30%);"
          src="../assets/login/close_icon.png" @click="apply = false" alt="">
        <div style="padding: 30px">
          <div style="text-align:center">
            <h2>尊敬的用户您好</h2>
            <p style="margin:10px">手机号将作为获取名额以及激励金的凭证，请谨慎填写</p>
          </div>
          <el-form :model="codeForm" :rules="codeRules" ref="codeForm" label-width="0px" class="demo-ruleForm"
            style="width: 90%;margin: 0 auto;margin-top: 20px;">
            <el-form-item prop="phone" style="margin-bottom:22px">
              <el-input v-model="codeForm.phone" placeholder="请输入手机号">
              </el-input>
            </el-form-item>
            <el-form-item prop="code" style="margin-bottom:22px">
              <el-input v-model="codeForm.code" placeholder="请输入验证码">
                <template #suffix>
                  <img v-if="showCodeMsg" style="height:70%; cursor: pointer;" @click="getCode"
                    src="../assets/login/apply_code.png" alt="">
                  <p v-if="!showCodeMsg">{{ count }}重新获取</p>
                </template>
              </el-input>
            </el-form-item>
            <div style="text-align: center;margin-top: 30px;">
              <img style="width: 90%; cursor: pointer;" @click="codeLogin('codeForm')"
                src="../assets/login/apply_btn.png" alt="">
            </div>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import router from '../router';

export default {

  data() {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else {
        const reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      dialogVisible: false,//弹框
      apply: false,//申请弹窗
      codeForm: {
        phone: "",
        code: "",
      },
      codeRules: {
        phone: [{ validator: phoneRules, trigger: "blur" }],
        code: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
      },
      from: '33',//固定传
      registSource: '1',//pc还是手机
      timer: null,//定时器
      count: "",//读秒
      showCodeMsg: true,//重新获取

    }
  },
  computed: {
    random() {
      return parseInt(Math.random() * (1999 - 1000) + 1000)
    }
  },
  mounted() {
    window.location.href='https://work.weixin.qq.com/kfid/kfcc7f894e85af548da'
    // this.judge()
  },
  methods: {
    addBtn() {
      this.apply = true
    },
    getCode() {
      this.$refs.codeForm.validateField("phone", (errorMsg) => {
        if (!errorMsg) {
          this.axios({
            method: "POST",
            url: "/loginController/getRCode",
            data: {
              phoneNum: this.codeForm.phone,
              checkFlag: "register",
              from: this.from
            }
          }).then(res => {
            if (res.data.status == 1) {
              const timcount = 60;
              if (!this.timer) {
                this.count = timcount;
                this.showCodeMsg = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= timcount) {
                    this.count--;
                  } else {
                    this.showCodeMsg = true;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000)
              }
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          })
        }
      })
    },
    jump() {
      this.$router.push('/selfHelp')
    },
    login() {
      this.$router.push('/login')
     },
    codeLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios({
            method: "POST",
            url: "/loginController/phoneRegister",
            data: {
              phoneNum: this.codeForm.phone,
              randCode: this.codeForm.code,
              from: "33",
              registSource: this.registSource
            },
          }).then((res) => {
            if (res.data.status >= 0) {
              this.$message({
                message: "获取激励名单成功",
                type: "success",
              });
              // window.sessionStorage.setItem("username", res.data.data.username);
              window.sessionStorage.setItem("userId", res.data.data.id);
              // window.sessionStorage.setItem("phoneNum", res.data.data.phoneNum);
              // this.$router.push("/home");
              this.apply = false
              this.dialogVisible = true
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    han() {
      window.open('https://www.haneton.com/')
    },
    judge() {
      var mobileAgent = new Array("iphone", "ipod", "ipad", "android", "mobile", "blackberry", "webos", "incognito", "webmate", "bada", "nokia", "lg", "ucweb", "skyfire");
      var browser = navigator.userAgent.toLowerCase();
      for (var i = 0; i < mobileAgent.length; i++) {
        if (browser.indexOf(mobileAgent[i]) != -1) {
          this.$router.push('/mobilehome')
          break;
        }
      }
    }
  }
}
</script>

<style scoped>
* {
  /* box-sizing: border-box;
  margin: 0;
  padding: 0; */
  list-style: none;
}

.all {
  height: 100%;
}

.header {
  height: 65px;
  padding: 0 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header .contact {
  display: inline-flex;
  align-items: center;
  color: #ffa854;
  font-size: 26px;
  font-weight: bold;
}

.head_img {
  position: relative;
  color: #f7f7f7;
}

.titlee {
  width: calc(100% - 30%);
  position: absolute;
  height: 45px;
  padding: 0 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top_bc {
  position: relative;
}

.top_bc .btn {
  position: absolute;
  top: 82%;
  left: 43%;
  width: 180px;
  cursor: pointer;
}

.top_bc .code {
  position: absolute;
  top: 40%;
  left: 27%;
  width: 6%;
  cursor: pointer;
}

.foo {
  position: relative;
}

.app {
  position: absolute;
  top: 70%;
  width: 80px;
  cursor: pointer;
}

.picture {
  margin: 0 auto;
  width: 100%;
}

.advantage {
  width: 100%;
  height: 85%;
  background: url('../assets/new_home/white_bc.png') no-repeat;
  background-size: 100% 100%;
  padding: 7% 12% 2% 12%;
  display: flex;
  font-size: 14px;
}

.advantage .left {
  flex: 1;
  background: url('../assets/new_home/white.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 30px 30px 20px 30px;
  text-align: center;
}

.advantage .center {
  flex: 1;
  background: url('../assets/new_home/red_ck.png') no-repeat;
  margin: 0 5px;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 30px 50px 20px 50px;
  text-align: center;
  color: #f7f7f7;
}

.advantage .advantage_icon {
  margin: 0 auto;
}

.footer {
  padding: 2% 15%;
  display: flex;
  justify-content: space-around;
  background-color: #3f3f3f;
  color: #f7f7f7;
}

.footer ul {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.footer ul li:first-child {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}

.footer ul li {
  margin-bottom: 6px;
  font-size: 13px;
}

.official {
  font-size: 13px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.official p {
  margin: 0;
  padding: 5px 0;
}

.official img {
  width: 100px;
}

.official:first-child {
  margin-bottom: 10px;
}

::v-deep .success .el-dialog__body {
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;
}

::v-deep .el-dialog__header {
  display: none;
}

::v-deep .success .el-dialog {
  width: auto;
  height: 70%;
  border-radius: 15px;
  background: url('../assets/login/envelope.png') no-repeat;
  background-size: cover;
  background-position: center;
}

::v-deep .apply .el-dialog {
  border-radius: 5px;
  background: url('../assets/login/apply_bc.png') no-repeat;
  background-size: cover;
  background-position: center;
}

::v-deep .apply .el-dialog__body {
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;
}

::v-deep .el-input__suffix {
  display: flex;
}

::v-deep .el-input__suffix-inner {
  display: flex;
  align-items: center;
}
</style>